import { Plugin } from 'prosemirror-state';
import { SylPlugin, SylUnionPlugin } from '../schema';
// parse the configuration of Plugins
var parseSylPluginConfig = function (sylPluginConfigs, adapter) {
    var sylPlugins = [];
    var nativePlugins = { top: [], bottom: [] };
    // the custom `Plugin.spec.prioritize` indicates whether to register first
    var addNativePlugin = function (plugin) {
        plugin.spec.prioritize ? nativePlugins.top.push(plugin) : nativePlugins.bottom.push(plugin);
    };
    var registerPlugin = function (sylPlugin, props) {
        sylPlugin.init(adapter, props);
        sylPlugins.push(sylPlugin);
    };
    var registerUnionPlugin = function (unionPlugin, props) {
        var _a = unionPlugin.install(adapter, props.controllerProps), _b = _a.nativePlugins, pmPlugins = _b === void 0 ? [] : _b, _c = _a.sylPlugins, sylPlugins = _c === void 0 ? [] : _c;
        pmPlugins.forEach(function (n) { return addNativePlugin(n); });
        sylPlugins.forEach(function (s) { return parseConfig(s); });
    };
    // Parse the `ISylPluginConfig`, which can be an object，`SylPlugin`, `SylUnionPlugin`, `prosemirror plugin` or their instance
    var parseConfig = function (config) {
        var pluginConfig = config;
        var props = {
            controllerProps: {},
        };
        // SylPlugin config object, property `plugin` maybe SylPlugin, SylUnionPlugin
        if (pluginConfig.plugin) {
            pluginConfig = pluginConfig.plugin;
            props.controllerProps = config.controllerProps || {};
            props.layers = config.layers || undefined;
        }
        if (pluginConfig instanceof Plugin) {
            // prosemirror plugin
            addNativePlugin(pluginConfig);
        }
        else if (pluginConfig instanceof SylPlugin) {
            // SylPlugin instance
            registerPlugin(pluginConfig, props);
        }
        else if (pluginConfig instanceof SylUnionPlugin) {
            // SylUnionPlugin instance
            registerUnionPlugin(pluginConfig, props);
        }
        else if (pluginConfig.prototype instanceof SylPlugin) {
            // SylPlugin
            registerPlugin(new pluginConfig(), props);
        }
        else if (pluginConfig.prototype instanceof SylUnionPlugin) {
            // SylUnionPlugin
            registerUnionPlugin(new pluginConfig(), props);
        }
    };
    sylPluginConfigs.forEach(parseConfig);
    return {
        sylPlugins: sylPlugins,
        nativePlugins: nativePlugins,
    };
};
export { parseSylPluginConfig };
//# sourceMappingURL=plugin-config-parse.js.map